import type { StaticEntityType } from "@config";
import { TICKER_PADDING_Y } from "../constants";
import { TickerCtxProvider } from "../ctx";
import { useTickerDetails } from "../hooks";
import "../styles/ticker.scss";
import type { ITickerEditorData } from "../types";
import { TickerItems } from "./ticker-items";

interface IProps {
  entity: StaticEntityType;
  editorData?: ITickerEditorData;
}

export const TickerView = ({ entity, editorData }: IProps) => {
  const {
    wrapperRef,
    itemsRef,
    elementSettings,
    isHorizontal,
    isVertical,
    isAnimReverse,
    aspectRatio,
    shouldAnimate,
    maxHeight,
    width,
    height,
    isEmpty,
  } = useTickerDetails({ entity, editorData });

  const hasFadeMask = !isEmpty && shouldAnimate;
  return (
    <TickerCtxProvider
      ctxState={{
        isHorizontal,
        isVertical,
        elementSettings,
        editorData,
        shouldAnimate,
        isAnimReverse,
      }}
    >
      <div
        className="tw-flex"
        style={{
          maxHeight: maxHeight > 0 ? `${maxHeight}px` : undefined,
          justifyContent: elementSettings.horizontalAlignment,
        }}
        onDoubleClick={editorData?.openEditDialog}
        ref={(r) => {
          const containerEditorRef = editorData?.containerRef;
          if (containerEditorRef) {
            containerEditorRef.current = r;
          }
        }}
      >
        {editorData?.resizeSlot}
        <div
          className="ticker-wrapper tw-relative tw-flex tw-overflow-hidden"
          ref={wrapperRef}
          data-mask={
            !hasFadeMask ? false : isHorizontal ? "horizontal" : "vertical"
          }
          style={{
            width: width,
            height: `${height}px`,
            paddingTop: `${isEmpty ? 0 : TICKER_PADDING_Y}px`,
            // @ts-ignore
            "--ticker-height": `${height - TICKER_PADDING_Y * 2}px`,
            "--ticker-ratio": aspectRatio,
            "--ticker-fade-out-ang": isVertical ? "180deg" : "90deg",
          }}
        >
          {isEmpty ? editorData?.emptySlot : <TickerItems ref={itemsRef} />}
        </div>
      </div>
    </TickerCtxProvider>
  );
};
